/**
 * Per-module configuration for the safe module retake flow. Any module that
 * appears here can be reset via `useModuleRetake`; anything not listed cannot
 * be reset from the client. Keep this list narrow — module retakes reverse
 * money, XP, and completion badges.
 */
export interface ModuleRetakeConfig {
  /** Human-readable module name for confirmation copy + toasts. */
  displayName: string;
  /** Lessons whose in-progress state should be cleared when the module resets. */
  lessonIds: string[];
  /** Achievement `name` ILIKE patterns whose grants should be revoked. */
  achievementNamePatterns: string[];
}

export const MODULE_RETAKE_CONFIG: Record<string, ModuleRetakeConfig> = {
  budget_builder: {
    displayName: "Budget Builder",
    lessonIds: [],
    achievementNamePatterns: ["%budget builder%"],
  },
  credit_management: {
    displayName: "Credit Management",
    lessonIds: [],
    achievementNamePatterns: ["%credit management%"],
  },
  scam_defense: {
    displayName: "Scam Defense",
    lessonIds: [],
    achievementNamePatterns: ["%scam defense%"],
  },
};

export function getModuleRetakeConfig(moduleKey: string): ModuleRetakeConfig | null {
  return MODULE_RETAKE_CONFIG[moduleKey] ?? null;
}